import apiClient from "./api";
import type { PosQueueStatus } from "@/utils/posQueue";

export interface SaleItem {
  product_id: number;
  product_code?: string;
  product_name?: string;
  quantity: number;
  unit_price: number;
  size_id?: number | null;
  sugar_id?: number | null;
  discount?: number;
  tax?: number;
}

export interface SaleData {
  customer_id?: number | null;
  warehouse_id: number;
  biller_id?: number | null;
  reference_no: string;
  items: SaleItem[];
  discount?: number;
  total_discount?: number;
  coupon_id?: number | null;
  coupon_discount?: number;
  tax_id?: number | null;
  tax?: number;
  shipping?: number;
  paid?: number;
  paid_by?: string;
  membership_card_id?: number | null;
  membership_card_number?: string | null;
  note?: string;
  status?: string;
  pos?: number;
}

export interface PosQueueSale {
  id: number;
  reference_no: string;
  customer_name?: string | null;
  warehouse_id?: number | null;
  warehouse_name?: string | null;
  grand_total?: number | string;
  paid?: number | string;
  paid_by?: string | null;
  payment_status?: string | null;
  queue_number?: number | null;
  queue_label?: string | null;
  queue_status?: PosQueueStatus | null;
  queue_completed_at?: string | null;
  created_at?: string;
  items?: Array<{
    id?: number;
    product_id?: number;
    product_name?: string;
    quantity?: number;
  }>;
}

export interface PosQueueFilters {
  warehouse_id?: number;
  status?: PosQueueStatus;
  limit?: number;
}

const posService = {
  async createSale(data: SaleData) {
    const response = await apiClient.post("/pos", data);
    return response.data;
  },
  async updateSale(id: number, data: SaleData) {
    const response = await apiClient.put(`/pos/${id}`, data);
    return response.data;
  },
  async getSales() {
    const response = await apiClient.get("/pos");
    return response.data;
  },
  async getSale(id: number) {
    const response = await apiClient.get(`/pos/${id}`);
    return response.data.data ?? response.data;
  },
  async getNextReference(): Promise<string> {
    const response = await apiClient.get("/pos/next-reference");
    return response.data.data ?? response.data;
  },
  async getQueueOrders(filters: PosQueueFilters = {}): Promise<PosQueueSale[]> {
    const response = await apiClient.get("/pos/queue", {
      params: filters,
    });
    return response.data.data ?? response.data;
  },
  async updateQueueStatus(
    id: number,
    queue_status: PosQueueStatus
  ): Promise<PosQueueSale> {
    const response = await apiClient.patch(`/pos/${id}/queue-status`, {
      queue_status,
    });
    return response.data.data ?? response.data;
  },
};

export default posService;
